import $ from 'jquery';
import HelperCtrl from './_helper';

const Helper = new HelperCtrl();

function FAQ_Ctrl() {
	this.$win = $(window);
	this.$target = $('#faqToggle');
	this.$targetContainer = this.$target.find('.faq-container');
	this.$targetItem = $('.faq_item');
	this.sideTop = undefined;
	this.$contact = $('#contactArea');
	this.$sidebar = $('#faqSidebar');
	this.sidebarOffset = this.$sidebar.offset();

	this.load = this.load.bind(this);
	this.clickQuestion = this.clickQuestion.bind(this);
	this.scrollSidebar = this.scrollSidebar.bind(this);

	this.init();
}

FAQ_Ctrl.prototype.init = function() {
	this.load();
	this.clickQuestion();
	this.clickAllOpen();

	// if ( ! Helper.isMobile()) {
	// 	this.scrollSidebar();
	// 	this.$win.on('scroll', this.scrollSidebar);
	// }
}

FAQ_Ctrl.prototype.load = function() {
	this.$targetItem.each(function() {
		const self = $(this);
		if (self.index() === 0) {
			self.addClass('select');
		}
	})
}

FAQ_Ctrl.prototype.clickQuestion = function() {
	this.$targetItem.find('.faq_item_q').on('click', function() {
		$(this).parent().toggleClass('select');
	});
}

FAQ_Ctrl.prototype.clickAllOpen = function() {
	$('.faq-all').on('click', function() {
		var target = $(this).parent('.faq_hl').next('.faq-container');
		target.toggleClass('active');
		if (target.hasClass('active')) {
			$(this).text('全て閉じる');
			target.find('.faq_item').addClass('select');
		} else {
			$(this).text('全て開く');
			target.find('.faq_item').removeClass('select');
		}
	})
}

FAQ_Ctrl.prototype.scrollSidebar = function(e) {
	var sidebarHeight = this.$sidebar.height();
	var sidebarOffset = this.$sidebar.offset();
	// var sidebarBottom = parseInt((sidebarOffset.top + sidebarHeight));
	var scTop = $(window).scrollTop();
	var mainHeight = $('#main').height();
	var mainBottom = parseInt(($('#main').offset().top + mainHeight));
	var sidebarBottom = (mainBottom - sidebarHeight - 80);
	console.log(mainBottom - sidebarHeight - 80, scTop);
	if (scTop > sidebarOffset.top - 80) {
		if (sidebarBottom < scTop) {
			this.$sidebar.css({
				top: sidebarBottom
			}).removeClass('sideFixed');
		} else {
			this.$sidebar.addClass('sideFixed');
		}
	} else {
		this.$sidebar.removeClass('sideFixed');
	}
}

export default FAQ_Ctrl